export const RTL_LANGUAGES = [
    'Arabic',
    'arabic',
    'Divehi',
    'Persian',
    'Hausa',
    'Hebrew',
    'Kashmiri',
    'Kurdish',
    'Pashto',
    'Urdu',
    'Yiddish'
];

export const LIBRARIAN_ROLE = "librarian";
export const LIBRARY_ADMIN_ROLE = "library-admin";
export const SUPER_ADMIN_ROLE = 'super-admin';
export const RESEARCHER_ROLE = 'researcher';
export const FREE_AGENT = 'free-agent';

export const MIME_TYPE_TO_EXTENSION = {
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/octet-stream": "docx",
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "text/plain": "txt",
    "application/zip": "zip",
};

export const PUBLICATIONS_VIEW = "publications";
export const USER_PUBLICATIONS_VIEW = "my_publications";
export const FILE_STATUS_OPTIONS = [
    { id: 'all', name: 'All Statuses' },
    { id: 'completed', name: 'Completed' },
    { id: 'partially_completed', name: 'Partially Completed' },
    { id: 'in_progress', name: 'In Progress' },
    { id: 'delivery_in_progress', name: 'Delivery In Progress' },
    { id: 'failed', name: 'Failed' },
    { id: 'pending', name: 'Pending' },
    { id: 'delivered', name: 'Delivered' },
    { id: 'out_of_scope', name: 'Out of Scope' }
];

export const ALLOWED_FILE_STATUS_TRANSITIONS = {
    pending: ["out_of_scope"],
    failed: ["pending", "completed", "out_of_scope"],
    delivered: ["pending", "completed"],
    completed: ["pending", "out_of_scope"],
    partially_completed: ["pending", "completed"],
    in_progress: ["pending", "partially_completed", "completed"],
    delivery_in_progress: ["completed","delivered"],
    out_of_scope: ["pending", "completed"]
}

export const ALMANDUMA_CUSTOMER = 'Almanduma'
